import BgzfFilehandle from './bgzFilehandle';
import { unzip, unzipChunk, unzipChunkSlice } from './unzip';
export { BgzfFilehandle, unzip, unzipChunk, unzipChunkSlice };